import { Shift } from 'domain/Shift';
import moment from 'moment';
import { alert } from 'store/alert';
import { refreshShiftRoster, refreshAvailabilityRoster } from 'store/roster/operations';
import { setMaxDateTime } from 'store/shift/actions';
import { KindaShiftView, shiftAdapter } from './KindaShiftView';
import { ThunkCommandFactory } from '../types';
import { Employee } from 'domain/Employee';
import { ThunkWithReturn } from 'store/types';

export const addShift: ThunkCommandFactory<Shift, any> = (shift) => (dispatch, state, client) => {
  const { tenantId } = shift;
  return client.post<KindaShiftView>(`/tenant/${tenantId}/shift/add`, shiftAdapter(shift))
    .then(() => {
      dispatch(refreshShiftRoster());
      dispatch(refreshAvailabilityRoster());
    })
    .catch((error) => {
      throw error;
    });
};

export const removeShift: ThunkCommandFactory<Shift, any> = (shift) => (dispatch, state, client) => {
  const { tenantId } = shift;
  const shiftId = shift.id;
  return client.delete<boolean>(`/tenant/${tenantId}/shift/${shiftId}`)
    .then((isSuccess) => {
      if (isSuccess) {
        dispatch(refreshShiftRoster());
        dispatch(refreshAvailabilityRoster());
      } else {
        dispatch(alert.showErrorMessage('removeShiftError', {
          id: shift.id,
          startDateTime: moment(shift.startDateTime).format('LLL'),
          endDateTime: moment(shift.endDateTime).format('LLL'),
        }));
      }
    })
    .catch((error) => {
      throw error;
    });
};

export const updateShift: ThunkCommandFactory<Shift, any> =
  (shift) => (dispatch, state, client) => {

    const { tenantId } = shift;

    return client.put<void>(
      `/tenant/${tenantId}/shift/update`,
      shiftAdapter(shift)
    )
    .then(() => {
      dispatch(refreshShiftRoster());
      dispatch(refreshAvailabilityRoster());
    })
    .catch((error) => {
      throw error;
    });
  };

export const loadMaxShiftEndDate: ThunkCommandFactory<number, any> =
  (tenantId) => async (dispatch, getState, client) => {
    try {
      const dateStr = await client.get<string | null>(`/tenant/${tenantId}/shift/max-end-datetime`);
      
      if (dateStr === null) {
        throw new Error('La fecha máxima de turnos no se recibió del servidor.');
      }

      const maxDate = new Date(dateStr);
      dispatch(setMaxDateTime(maxDate));
      return maxDate;
    } catch (error) {
      console.error('Error al obtener la fecha máxima de turnos:', error);
      throw error;
    }
  };

export const getAvailableEmployees =
  (
    tenantId: number,
    shiftId: number,
    allowOvertime: boolean
  ): ThunkWithReturn<Employee[]> =>
  async (dispatch, getState, client) => {

    const employees = await client.get<Employee[]>(
      `/tenant/${tenantId}/shift/${shiftId}/available-employees?allowOvertime=${allowOvertime}`
    );

    return employees ?? [];
  };

export const getAvailableEmployeesForNewShift =
  (
    shift: Shift,
    allowOvertime: boolean
  ): ThunkWithReturn<Employee[]> =>
  async (dispatch, getState, client) => {

    const { tenantId } = shift;

    const employees = await client.post<Employee[]>(
      `/tenant/${tenantId}/shift/available-employees?allowOvertime=${allowOvertime}`,
      shiftAdapter(shift)
    );

    return employees ?? [];
  };